import React, {Component} from 'react';
import NewCardInfoDetailAnimal from "./cards/NewCardInfoDetailAnimal";
import CardInfoAnimalDetailProtectora from "./cards/CardInfoAnimalDetailProtectora";
import {browserHistory} from "react-router";
import AnimalList from "../../../AnimalList/components/AnimalList";
import {PATH_ADOPTAR} from "../../../../App/RouterAdopta";
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";

class AnimalDetailContainer extends Component {
    
    constructor(props) {
        super(props);
        
        const width = window.innerWidth;
        if (width < 992) {
            this.state = {
                elementsPerPage: 4,
                elementsPerRow: 2
            }
        } else {
            this.state = {
                elementsPerPage: 3,
                elementsPerRow: 3
            }
        }
    }
    
    
    render() {
        //console.log("MapContainer::render()");
        
        let showAnimal, showProtectora, showAnimalsProtectora, showAnimalsRecomendation;
        
        if (this.props.infoAnimalDetail && (Object.keys(this.props.infoAnimalDetail).length > 1)) {
            showAnimal = true
        }
        
        if (this.props.infoProtectoraDetail && (Object.keys(this.props.infoProtectoraDetail).length > 1)) {
            showProtectora = true
        }
        
        if (this.props.infoProtectoraDetail && this.props.animalsProtectora.animals && this.props.animalsProtectora.animals.length > 0) {
            showAnimalsProtectora = true
        }
        
        if (this.props.recomendations && this.props.recomendations.animals && this.props.recomendations.animals.length > 0) {
            showAnimalsRecomendation = true
        }
        
        
        return (
            <div key={"container-" + this.props.idAnimal}>
                
                <div>
                    <div className="botoneraHeader">
                        <div className="infoDetailProOneColumn">
                            <button onClick={this.goBack} href="#" type="button"
                               className="btn btn-outline-primary listing-houses__item-view-link">
                                <span className="las la-lg la-arrow-left" aria-hidden="true"/>{' '} Volver
                            </button>
                        </div>
                    </div>
                </div>
                {(this.props.infoAnimalDetail.estado === "Adoptado") &&
                    <div className="s-alert-success s-alert-is-effect s-alert-effect-slide s-alert-show"
                         id="alert-animal-adoptado" /*style="top: 30px; right: 30px;"*/>
                        <div className="s-alert-box-inner">
                            <span className="las la-2x la-exclamation-triangle"></span>
                            <span><strong>{this.props.infoAnimalDetail.nombre}</strong> ya ha sido adoptado por una buena familia</span>
                        </div>
                    </div>
                }
                <div className="section">
                    {this.props.infoAnimalDetail &&
                        <NewCardInfoDetailAnimal
                            infoAnimalDetail={this.props.infoAnimalDetail}
                            infoProtectoraDetail={this.props.infoProtectoraDetail}
                            
                            animalsControl={this.props.animalsControl}
                            animalsControlDetail={this.props.animalsControlDetail}
                            modeEmail={this.props.modeEmail}
                            index={this.props.index}
                            isAdminAnimals={this.props.isAdminAnimals}
                            onSendEmail={this.props.onSendEmail}
                        />
                    }
                </div>

                <AdsManagerContainer type={ADS_TYPES.SPLITSCREEN}/>

                {showProtectora &&
                    <div>
                        <hr/>
                        <div className="section">
                            
                            <CardInfoAnimalDetailProtectora
                                infoProtectoraDetail={this.props.infoProtectoraDetail}
                                index={this.props.index}
                                idAnimal={this.props.infoAnimalDetail._id}
                                animalsControl={this.props.animalsControl}
                                animalsControlDetail={this.props.animalsControlDetail}
                            />
                        </div>
                    </div>
                }
                <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>

                {showAnimalsProtectora &&
                    
                    <div>
                        <hr/>
                        <div className="section">
                            <div className="cardInfoTitle">
                                <h2 className="card-subtitle">Otros {(this.props.infoAnimalDetail.especie === "Perro") ? "perros" : "gatos"} de
                                    <span className="bold">{" " + this.props.infoProtectoraDetail.nombre} </span>
                                </h2>
                            
                            </div>
                            <div id="animals-list-container" className="">
                                <AnimalList
                                    list={this.props.animalsProtectora.animals}
                                    isReady={true}
                                    totalRecord={this.props.animalsProtectora.totalRecord}
                                    pag={this.props.animalsProtectora.pag}
                                    elementsPerRow={this.state.elementsPerRow}
                                    elementsPerPage={this.state.elementsPerPage}
                                    animalsControl={this.props.animalsControl}
                                    animalsControlDetail={this.props.animalsControlDetail}
                                    isAdminAnimals={false}
                                    access={this.props.access}
                                    isRecomendationCards
                                />
                            </div>
                        </div>
                    </div>
                    
                }
                <AdsManagerContainer type={ADS_TYPES.MEGABANNER} onlyMobile/>

                {showAnimalsRecomendation &&
                    
                    <div>
                        <hr/>
                        <div className="section">
                            <div className="cardInfoTitle">
                                <h2 className="card-subtitle">Más {(this.props.infoAnimalDetail.especie === "Perro") ? "perros" : "gatos"} que
                                    te pueden gustar <span className="bold"></span>
                                </h2>
                            
                            </div>
                            <div id="animals-list-container" className="">
                                <AnimalList
                                    list={this.props.recomendations.animals}
                                    isReady={true}
                                    totalRecord={this.props.recomendations.animals.length}
                                    pag={0}
                                    elementsPerRow={this.state.elementsPerRow}
                                    elementsPerPage={this.state.elementsPerPage}
                                    animalsControl={this.props.animalsControl}
                                    animalsControlDetail={this.props.animalsControlDetail}
                                    isAdminAnimals={false}
                                    access={this.props.access}
                                    isRecomendationCards
                                />
                            </div>
                        </div>
                    </div>
                    
                }
                <AdsManagerContainer type={ADS_TYPES.BILLBOARD}/>


                {/*</div>*/}
                {/*<Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>*/}
                {/* </div>*/}
            </div>
        );
    }
    
    
    goBack() {
        //console.log("MapContainer::goBack()");
        browserHistory.push(PATH_ADOPTAR);
    }
    
    componentWillMount() {
    }
    
    componentDidMount() {
    }
    
    
    componentWillUpdate(nextProps, nextState, nextContext) {
        //console.log("MapContainer::componentWillUpdate()");
        
    }
    
    
    componentDidUpdate() {
        // if (this.props.waitBlock.showWaitBlock) {
        //     $('#modal-container').removeClass('out').addClass("one");
        //     $('body').addClass('modal-active');
        // } else {
        //     $('body').removeClass('modal-active');
        // }
    }
}

export default AnimalDetailContainer
